/**
 * Desktop layout for Home: sidebar "С чего начать?", main column with анонсы and "Жизнь церкви".
 */

import { Link } from "react-router-dom";
import { ListSkeleton } from "../../components/ui/Skeleton.tsx";
import {
  IconMessage,
  IconEnvelope,
  IconMapPin,
  IconReceipt,
} from "../../components/Icons.tsx";
import { EventCarousel } from "./EventCarousel.tsx";
import { QuickActionsGrid } from "./QuickActionsGrid.tsx";
import { StartCards } from "./HomePageShared.tsx";
import { BOTTOM_LINKS } from "../../config/home.ts";
import type { Event } from "../../lib/graphql.ts";

interface HomePageDesktopProps {
  events: Event[];
  isLoading: boolean;
}

export function HomePageDesktop({ events, isLoading }: HomePageDesktopProps) {
  return (
    <>
      {/* Основной контент: сайдбар слева, анонсы и жизнь церкви справа */}
      <div className="grid grid-cols-[280px_1fr] gap-6 items-start">
        {/* 1. С чего начать? — сайдбар-карточка, row-span-2 */}
        <aside className="col-start-1 row-span-2 row-start-1">
          <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm border border-slate-100 ring-1 ring-slate-200/50 p-4">
            <div className="grid grid-cols-1 gap-3">
              <StartCards />
            </div>
          </div>
        </aside>

        {/* 2. Анонсы — без карточки */}
        <section className="col-start-2 row-start-1 w-full min-w-0">
          {isLoading ? (
            <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-6">
              <ListSkeleton count={2} />
            </div>
          ) : (
            <EventCarousel events={events} />
          )}
        </section>

        {/* 3. Жизнь церкви — карточка */}
        <section className="col-start-2 row-start-2 mt-0">
          <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm border border-slate-100 ring-1 ring-slate-200/50 p-4">
            <p className="section-title px-0">Жизнь церкви</p>
            <div className="mt-1">
              <QuickActionsGrid />
            </div>
          </div>
        </section>
      </div>

      {/* Есть вопросы? — компактный футер, ссылки в ряд */}
      <div className="mt-8 pt-6 border-t border-slate-200/60">
        <p className="section-title px-0 mb-2">Есть вопросы? Мы рядом</p>
        <div className="flex flex-wrap gap-2">
          {BOTTOM_LINKS.map((item) => {
            const Icon =
              item.icon === "message"
                ? IconMessage
                : item.icon === "envelope"
                  ? IconEnvelope
                  : item.icon === "mapPin"
                    ? IconMapPin
                    : IconReceipt;
            return (
              <Link
                key={item.path}
                to={item.path}
                className="inline-flex items-center gap-2 py-2 px-3 rounded-lg bg-slate-50 border border-slate-100 active:bg-slate-100 transition-colors no-underline text-inherit text-sm font-medium text-slate-700"
                aria-label={item.label}
              >
                <Icon className="w-4 h-4 text-slate-500" />
                {item.label}
              </Link>
            );
          })}
        </div>
      </div>

      {/* Bottom spacing for tab bar */}
      <div className="h-4" />
    </>
  );
}
